/**
 * Faz o parse do corpo de uma `Response` como JSON, nunca deixando um
 * `SyntaxError` cru escapar para as camadas de apresentação (LOCAL-001).
 *
 * No 1º load frio, o Service Worker (`NetworkFirst`, `sw.ts`) pode entregar
 * uma resposta cujo corpo não é JSON válido — ex. race de rede resolvida
 * antes do corpo estar completo, ou resposta de erro em HTML de um proxy
 * intermediário. `response.json()` rejeita nesse caso com a mensagem nativa
 * do parser (`Unexpected end of JSON input`, etc.), que `ConfigLoadingScreen`
 * renderiza sem tradução. Este guard relança sempre `fallbackMessage`,
 * amigável ao usuário final.
 */
export async function parseJsonResponse<T>(response: Response, fallbackMessage: string): Promise<T> {
  try {
    return (await response.json()) as T;
  } catch {
    throw new Error(fallbackMessage);
  }
}
